import gql from 'graphql-tag';

export const END_MODULE_MUTATION = gql`
  mutation endUserFlowTrackStep($userFlowStepTrackId: Int!) {
    userFlowStepTrack {
      endUserFlowStep(trackingId: $userFlowStepTrackId, status: COMPLETED) {
        id
      }
    }
  }
`;
